function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
import { fetchWithCsrf } from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';
import { updateButtons } from 'js/profiles/setUpLeftSidebarButtons';
import { getAutoProps } from 'js/auto_props/client';
Aedu.ResearchInterestListCard = class ResearchInterestListCard extends HoverPopover {
  initialize(options) {
    var _getAutoProps;
    super.initialize({
      html: true,
      placement: 'bottom',
      container: this.cardContainer(),
      show_delay: 400,
      hide_delay: 250,
      content: () => this.cardContent(),
      template: (() =>
      // Maybe we should alwaays just use our own template?
      $($.fn.popover.Constructor.DEFAULTS.template).addClass('popover-hovercard ri-list-card'))(),
      // We are explicitly specifying the template, so no need to sanitize
      sanitize: false
    });
    const follows = ((_getAutoProps = getAutoProps('UserFollows')) === null || _getAutoProps === void 0 ? void 0 : _getAutoProps.followedResearchInterests) || [];
    this.follows = follows.reduce((acc, follow) => {
      acc[follow.id] = true;
      return acc;
    }, {});
    this.list = this.getResearchInterestListFromOptions(options);
    if (this.list != null) {
      this.on_shown = popoverElement => {
        this.activateFollowAndUnfollowButtons();
        this.showStats(popoverElement);
      };
    }
    return Aedu.Behaviors.ScrollScope.enable(this._popover_el().find('.popover-content'));
  }
  getResearchInterestListFromOptions(options) {
    // Need to remove the Research Interest we are already showing
    let ri;
    const ri_id = this.$el.data('remove-ri');
    const riList = [];
    // works have research_interests and users have interests
    // this lets work actually be a user instead.
    if (options.work.research_interests != null) {
      for (ri of Array.from(options.work.research_interests)) {
        if (ri.id !== ri_id) {
          riList.push(new Aedu.ResearchInterest(ri));
        }
      }
    } else if (options.work.interests != null) {
      for (ri of Array.from(options.work.interests)) {
        if (ri.id !== ri_id) {
          riList.push(new Aedu.ResearchInterest(ri));
        }
      }
    }
    // Sort the list
    if (Aedu.User.current != null) {
      return riList.sort((a, b) => Number(!this.follows[a.id]) - Number(!this.follows[b.id]));
    } else {
      return riList;
    }
  }
  showStats($popover) {
    // Don't actually start loading the data till we're showing the ri card;
    // we don't want to load it for every ri by default on a page with many.
    return Array.from(this.list).map(ri =>
    // do ensures that we have the correct selector when the done callback is executed
    function () {
      const selector = `*[data-stats-for-ri=${ri.get('id')}] .js-ri-card-stat-num[data-stat=followers_count]`;
      return ri.loadFollowersCount().done(c => $popover.find(selector).text($h.commaizeInt(c)));
    }());
  }
  activateFollowAndUnfollowButtons() {
    document.querySelectorAll('[data-follow-ri-id]').forEach(element => {
      element.addEventListener('click', e => _async_to_generator(function* () {
        e.preventDefault();
        const el = e.currentTarget;
        const researchInterestId = el.getAttribute('data-follow-ri-id');
        const res = yield followRI(researchInterestId);
        updateButtons(el, `[data-unfollow-ri-id="${researchInterestId}"]`, res.ok);
      })());
    });
    document.querySelectorAll('[data-unfollow-ri-id]').forEach(element => {
      element.addEventListener('click', e => _async_to_generator(function* () {
        if (!Aedu.User.current) {
          return;
        }
        e.preventDefault();
        const el = e.currentTarget;
        const researchInterestId = el.getAttribute('data-unfollow-ri-id');
        const res = yield unfollowRI(researchInterestId);
        updateButtons(el, `[data-follow-ri-id="${researchInterestId}"]`, res.ok);
      })());
    });
    const followRI = researchInterestId => _async_to_generator(function* () {
      const res = yield postFollowRI(researchInterestId, routes.add_api_v0_taggings_path({
        subdomain_param: 'api',
        tag_type: 'ResearchInterest',
        target_type: 'User',
        target_id: Aedu.User.current.id
      }));
      yield res.json();
      // We only want to record if ajax call was successful
      this.follows[researchInterestId] = true;
      return res;
    }).call(this);
    const unfollowRI = researchInterestId => _async_to_generator(function* () {
      const res = yield postFollowRI(researchInterestId, routes.remove_api_v0_taggings_path({
        subdomain_param: 'api',
        tag_type: 'ResearchInterest',
        target_type: 'User',
        target_id: Aedu.User.current.id
      }));
      this.follows[researchInterestId] = false;
      return res;
    }).call(this);
    const postFollowRI = (researchInterestId, url) => _async_to_generator(function* () {
      const response = yield fetchWithCsrf(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tag: {
            id: researchInterestId
          }
        })
      });
      return response;
    })();
  }
  cardContent() {
    return JST['core_post_webpack/sitewide_business_elements/research_interest_list_card/templates/card']({
      ris: this.list,
      follows: this.follows
    });
  }
  cardContainer() {
    // If popover trigger's parent allows "non-phrasing" elements as children
    // and has .bootstrap as a parent we can have the popover card appended to it
    // If it isnt then we want to append it to the bootstrap container at bottom
    // of body (container needed because the popover needs namespaced bootstrap)
    // Why we have to do this:
    // http://stackoverflow.com/questions/9852312/list-of-html5-elements-that-can-be-nested-inside-p-element
    // The second part of this conditional should be removed after bootstrap is
    // no longer namespaced
    if (!this.$el.parent().is('div, li') || !this.$el.parents('.bootstrap').length) {
      return '#bootstrap-modal-container';
    }
  }
};
window.asyncGeneratorStep = asyncGeneratorStep;
window._async_to_generator = _async_to_generator;
window.fetchWithCsrf = fetchWithCsrf;
window.routes = routes;
window.updateButtons = updateButtons;
window.getAutoProps = getAutoProps;